import { select } from 'redux-saga/effects';

import type { LxStoreState } from '@maggie/store/types';
import { UserSelectors } from '@maggie/store/user/selectors';

export function* handleDidNavigateToSignUp(): any {
  // If you're logged in, it redirects you to home
  const token: ReturnType<typeof UserSelectors.getToken> = yield select<LxStoreState>(
    UserSelectors.getToken
  );

  if (!!token) {
    return window.__router.navigate('home', {});
  }
}
